export default __webpack_public_path__ + "static/media/survey.fa7bb0b3.png";